/* eslint-disable */
type CrTimestamp = number;
type CrJson = any;
type CrBigInt = number;
/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetPdpIntegratedData
// ====================================================

export interface GetPdpIntegratedData_related_product_review_summary_overview_description_color {
  normal: string | null;
}

export interface GetPdpIntegratedData_related_product_review_summary_overview_description {
  text: string;
  color: GetPdpIntegratedData_related_product_review_summary_overview_description_color | null;
}

export interface GetPdpIntegratedData_related_product_review_summary_overview_aggregate_internal {
  /**
   * 리뷰 수
   */
  count: number;
  /**
   * 노출용 리뷰 수
   */
  display_count: string;
  /**
   * 평균 평점
   */
  average_rating: number;
}

export interface GetPdpIntegratedData_related_product_review_summary_overview_aggregate_total {
  /**
   * 리뷰 수
   */
  count: number;
  /**
   * 노출용 리뷰 수
   */
  display_count: string;
  /**
   * 평균 평점
   */
  average_rating: number;
}

export interface GetPdpIntegratedData_related_product_review_summary_overview_aggregate {
  /**
   * 내부 리뷰 집계
   */
  internal: GetPdpIntegratedData_related_product_review_summary_overview_aggregate_internal;
  /**
   * 전체 리뷰 집계
   */
  total: GetPdpIntegratedData_related_product_review_summary_overview_aggregate_total;
}

export interface GetPdpIntegratedData_related_product_review_summary_overview {
  /**
   * 개요 설명
   */
  description: GetPdpIntegratedData_related_product_review_summary_overview_description | null;
  /**
   * 전체 리뷰 통계 정보
   */
  aggregate: GetPdpIntegratedData_related_product_review_summary_overview_aggregate;
}

export interface GetPdpIntegratedData_related_product_review_summary {
  /**
   * 리뷰 개요
   */
  overview: GetPdpIntegratedData_related_product_review_summary_overview;
}

export interface GetPdpIntegratedData_ux_review_list_item_list_requested_user {
  is_abuse_reported: boolean;
}

export interface GetPdpIntegratedData_ux_review_list_item_list_image_list {
  /**
   * 썸네일 파일 URL
   */
  thumbnail_url: string;
}

export interface GetPdpIntegratedData_ux_review_list_item_list_video_list {
  /**
   * 썸네일 url
   */
  thumbnail_url: string | null;
}

export interface GetPdpIntegratedData_ux_review_list_item_list_reviewer_profile {
  /**
   * 마스킹 처리된 이메일
   */
  masked_email: string;
}

export interface GetPdpIntegratedData_ux_review_list_item_list_reviewer {
  /**
   * 리뷰 작성자 프로필 정보
   */
  profile: GetPdpIntegratedData_ux_review_list_item_list_reviewer_profile;
}

export interface GetPdpIntegratedData_ux_review_list_item_list {
  /**
   * 레코드 ID
   */
  id: string;
  /**
   * 리뷰 내용
   */
  contents: string;
  /**
   * 평점
   */
  rating: number;
  /**
   * 요청한 사용자별 정보
   */
  requested_user: GetPdpIntegratedData_ux_review_list_item_list_requested_user | null;
  /**
   * 상품 리뷰 이미지 목록
   */
  image_list: GetPdpIntegratedData_ux_review_list_item_list_image_list[];
  /**
   * 상품 리뷰 동영상 목록
   */
  video_list: GetPdpIntegratedData_ux_review_list_item_list_video_list[];
  /**
   * 리뷰 작성자 사용자계정 정보
   */
  reviewer: GetPdpIntegratedData_ux_review_list_item_list_reviewer;
}

export interface GetPdpIntegratedData_ux_review_list {
  item_list: GetPdpIntegratedData_ux_review_list_item_list[];
}

export interface GetPdpIntegratedData_pdp_base_info_catalog_product_extra_notice_banner {
  title: string;
  notice_id: string | null;
}

export interface GetPdpIntegratedData_pdp_base_info_catalog_product {
  /**
   * CMS 공지 배너
   */
  extra_notice_banner: GetPdpIntegratedData_pdp_base_info_catalog_product_extra_notice_banner | null;
}

export interface GetPdpIntegratedData_pdp_base_info_epick_list {
  id: string;
  /**
   * 게시글 이미지
   */
  image_url: string;
  /**
   * 랜딩 URL
   */
  landing_url: string;
  /**
   * 에픽 유저 닉네임
   */
  nickname: string;
}

export interface GetPdpIntegratedData_pdp_base_info_size_recommendation_option_value_list_height_range {
  min: number;
  max: number;
}

export interface GetPdpIntegratedData_pdp_base_info_size_recommendation_option_value_list_weight_range {
  min: number;
  max: number;
}

export interface GetPdpIntegratedData_pdp_base_info_size_recommendation_option_value_list_answer {
  percent: number;
  value: string;
}

export interface GetPdpIntegratedData_pdp_base_info_size_recommendation_option_value_list {
  ranking: number;
  name: string;
  height_range: GetPdpIntegratedData_pdp_base_info_size_recommendation_option_value_list_height_range | null;
  weight_range: GetPdpIntegratedData_pdp_base_info_size_recommendation_option_value_list_weight_range | null;
  size_with_category: string | null;
  answer: GetPdpIntegratedData_pdp_base_info_size_recommendation_option_value_list_answer | null;
  purchase_percent: number | null;
}

export interface GetPdpIntegratedData_pdp_base_info_size_recommendation_user_account_body {
  /**
   * 신장
   */
  height: number;
  /**
   * 체중
   */
  weight: number;
  /**
   * 사이즈에 대한 문구, e.g. '하의 27'
   */
  size_text: string | null;
}

export interface GetPdpIntegratedData_pdp_base_info_size_recommendation_user_account {
  name: string | null;
  body: GetPdpIntegratedData_pdp_base_info_size_recommendation_user_account_body | null;
}

export interface GetPdpIntegratedData_pdp_base_info_size_recommendation_user_body_input_info_selection_list {
  key: string;
  label: string;
  min: number;
  max: number;
  gap: number;
  measure_unit: string;
  selected_value: number | null;
  anchor: number;
  placeholder: string;
}

export interface GetPdpIntegratedData_pdp_base_info_size_recommendation_user_body_input_info {
  html_title: string;
  selection_list: GetPdpIntegratedData_pdp_base_info_size_recommendation_user_body_input_info_selection_list[];
}

export interface GetPdpIntegratedData_pdp_base_info_size_recommendation {
  recommendation_type: PdpProductSizeType;
  option_value_list: GetPdpIntegratedData_pdp_base_info_size_recommendation_option_value_list[];
  user_account: GetPdpIntegratedData_pdp_base_info_size_recommendation_user_account | null;
  user_body_input_info: GetPdpIntegratedData_pdp_base_info_size_recommendation_user_body_input_info | null;
  is_review_button_visible: boolean;
}

export interface GetPdpIntegratedData_pdp_base_info_fitting_model_list_item_list_badge {
  label: string;
}

export interface GetPdpIntegratedData_pdp_base_info_fitting_model_list_item_list {
  id: string;
  name: string;
  badge: GetPdpIntegratedData_pdp_base_info_fitting_model_list_item_list_badge | null;
  fitting_size_list: string[] | null;
  size_text_list: string[];
  profile_image_url: string;
}

export interface GetPdpIntegratedData_pdp_base_info_fitting_model_list {
  item_list: GetPdpIntegratedData_pdp_base_info_fitting_model_list_item_list[];
}

export interface GetPdpIntegratedData_pdp_base_info_policy_list_content_list {
  title: string;
  description: string;
}

export interface GetPdpIntegratedData_pdp_base_info_policy_list {
  main_title: string;
  content_list: GetPdpIntegratedData_pdp_base_info_policy_list_content_list[];
}

export interface GetPdpIntegratedData_pdp_base_info {
  /**
   * 입점형 내재화 상품정보
   */
  catalog_product: GetPdpIntegratedData_pdp_base_info_catalog_product;
  /**
   * 연관된 에픽 정보
   */
  epick_list: GetPdpIntegratedData_pdp_base_info_epick_list[];
  /**
   * 사이즈 추천 정보
   */
  size_recommendation: GetPdpIntegratedData_pdp_base_info_size_recommendation | null;
  /**
   * 상품 피팅 모델 정보
   */
  fitting_model_list: GetPdpIntegratedData_pdp_base_info_fitting_model_list | null;
  /**
   * 정책 및 약관
   */
  policy_list: GetPdpIntegratedData_pdp_base_info_policy_list[];
}

export interface GetPdpIntegratedData_pdp_size_info_item_list {
  image_url: string | null;
  value_list: string[][];
  description: string[];
  is_size_comparable: boolean;
  is_edit_request_clicked: boolean | null;
  is_ai_image_zoom_button_visible: boolean | null;
}

export interface GetPdpIntegratedData_pdp_size_info {
  item_list: GetPdpIntegratedData_pdp_size_info_item_list[];
}

export interface GetPdpIntegratedData_pdp_short_form_contents_content_list {
  id: string;
  title: string;
  thumbnail_image_url: string;
  video_url: string;
}

export interface GetPdpIntegratedData_pdp_short_form_contents {
  content_list: GetPdpIntegratedData_pdp_short_form_contents_content_list[] | null;
}

export interface GetPdpIntegratedData_pdp_option_info_catalog_product_matching_catalog_product_info_shipping_fee {
  /**
   * 배송비 타입
   */
  fee_type: PdpShippingFeeType;
  /**
   * 기본 배송비
   */
  base_fee: number;
  /**
   * 조건부 무료 배송비
   */
  minimum_free_shipping_fee: number | null;
}

export interface GetPdpIntegratedData_pdp_option_info_catalog_product_matching_catalog_product_info {
  id: string;
  /**
   * 상품 url
   */
  pdp_url: string;
  browsing_type: PdpBrowsingType;
  /**
   * 솔루션사 관리코드
   */
  external_code: string | null;
  /**
   * 배송비
   */
  shipping_fee: GetPdpIntegratedData_pdp_option_info_catalog_product_matching_catalog_product_info_shipping_fee | null;
}

export interface GetPdpIntegratedData_pdp_option_info_catalog_product {
  /**
   * 직진배송에 매칭되는 상품 정보
   */
  matching_catalog_product_info: GetPdpIntegratedData_pdp_option_info_catalog_product_matching_catalog_product_info | null;
}

export interface GetPdpIntegratedData_pdp_option_info {
  /**
   * 입점형 내재화 상품정보
   */
  catalog_product: GetPdpIntegratedData_pdp_option_info_catalog_product;
}

export interface GetPdpIntegratedData {
  /**
   * 리뷰 그룹 요약
   */
  related_product_review_summary: GetPdpIntegratedData_related_product_review_summary;
  /**
   * 리뷰 리스트 조회
   */
  ux_review_list: GetPdpIntegratedData_ux_review_list;
  /**
   * PDP 기본 정보 (source = 네이버 등 제휴사를 통해 유입된 캠페인 코드)
   */
  pdp_base_info: GetPdpIntegratedData_pdp_base_info | null;
  /**
   * 상품 사이즈 정보
   */
  pdp_size_info: GetPdpIntegratedData_pdp_size_info | null;
  /**
   * 숏폼 콘텐츠
   */
  pdp_short_form_contents: GetPdpIntegratedData_pdp_short_form_contents | null;
  /**
   * 입점형 PDP 상품 옵션 정보
   * catalog_product_detail_page와 동일한 타입을 반환하지만 옵션과 관련된 필드만 채워서 응답한다.
   */
  pdp_option_info: GetPdpIntegratedData_pdp_option_info | null;
}

export interface GetPdpIntegratedDataVariables {
  catalog_product_id: string;
  limit_count?: number | null;
  order?: UxReviewListOrderType | null;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetReviewPredictionSummary
// ====================================================

export interface GetReviewPredictionSummary_ux_review_prediction_summary {
  rating: number | null;
}

export interface GetReviewPredictionSummary {
  /**
   * 예측 리뷰 통계 조회
   */
  ux_review_prediction_summary: GetReviewPredictionSummary_ux_review_prediction_summary | null;
}

export interface GetReviewPredictionSummaryVariables {
  product_id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

// ====================================================
// GraphQL query operation: GetHasExternalReview
// ====================================================

export interface GetHasExternalReview_ux_external_product_review_tab {
  /**
   * 노출 여부
   */
  is_exposed: boolean;
  /**
   * 우선 노출 여부
   */
  is_prior: boolean;
}

export interface GetHasExternalReview {
  /**
   * 외부 상품 리뷰 탭 노출 여부 조회
   */
  ux_external_product_review_tab: GetHasExternalReview_ux_external_product_review_tab;
}

export interface GetHasExternalReviewVariables {
  product_id: string;
}

/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum PdpBrowsingType {
  DETAIL_BROWSER = "DETAIL_BROWSER",
  INTERNAL_BROWSER = "INTERNAL_BROWSER",
  NATIVE_BROWSER = "NATIVE_BROWSER",
  NORMAL = "NORMAL",
  Z_BROWSER = "Z_BROWSER",
}

export enum PdpProductSizeType {
  NONE = "NONE",
  OPTION = "OPTION",
  PURCHASE = "PURCHASE",
  RECOMMENDATION = "RECOMMENDATION",
}

export enum PdpShippingFeeType {
  CHARGED = "CHARGED",
  CONDITIONAL_FREE = "CONDITIONAL_FREE",
  FREE = "FREE",
}

/**
 * 상품리뷰 목록 정렬
 */
export enum UxReviewListOrderType {
  BEST_SCORE_DESC = "BEST_SCORE_DESC",
  DATE_CREATED_DESC = "DATE_CREATED_DESC",
  EXPERIENCE_GROUP_BEST_SCORE_DESC = "EXPERIENCE_GROUP_BEST_SCORE_DESC",
  LIKE_COUNT_DESC = "LIKE_COUNT_DESC",
  RATING_ASC = "RATING_ASC",
  RATING_DESC = "RATING_DESC",
  SCORE_DESC = "SCORE_DESC",
}

//==============================================================
// END Enums and Input Objects
//==============================================================
